import React from 'react';
import { CutoutModel } from '../../../../../Models/CutoutModel';
import { VehicleModel } from '../../../../../Models/VehicleModel';
import { CutoutVehicleChipList } from './CutoutVehicleChipList';
import { EditAction } from '../../../../../shared/enum/EditAction';
import { ClientContext } from '../../../ClientContext';
import { Grid } from '@material-ui/core';
import { FilterChipsSearchField } from '../../../../../shared/components/FilterChipsSearchField';

interface ICutoutVehiclesProps {
    cutout: CutoutModel,
    setCutout: (cutout: CutoutModel) => void
}


export function CutoutVehicles({ cutout, setCutout }: ICutoutVehiclesProps) {
    const clientContext = React.useContext(ClientContext);

    const [searchText, setSearchText] = React.useState<string>('');
    const [vehicleList, setVehicleList] = React.useState<VehicleModel[]>([]);

    React.useEffect(() => {

        if (clientContext.vehicles.length > 0) {
            const vehicles = [ ...clientContext.vehicles];
            const activeVehicles = vehicles.filter(v => v.editAction != EditAction.DELETE);
            setVehicleList(activeVehicles);
        }
        else {
            setVehicleList([]);
        }

    }, [clientContext.vehicles.length]);
    
    const sortVehicles = (list: VehicleModel[]) => {
        return list.sort((a,b) => compareSortVehicle(a,b));
    };

    const compareSortVehicle = (a: VehicleModel, b: VehicleModel) => {
        if (a.nomenclature && b.nomenclature) {
            return a.nomenclature.localeCompare(b.nomenclature);
        }
        else {
            return a.name.localeCompare(b.name);
        }
    };

    const handleSelectVehicle = (vehicle: VehicleModel) => {
        const currentVehicle = { ...vehicle };
        const currentCutout = { ...cutout };
        const selectedVehicles = currentCutout.vehicles;

        const index = selectedVehicles.findIndex(v => v.id === currentVehicle.id);

        if (index > -1 && selectedVehicles[index].editAction == EditAction.DELETE) {
            selectedVehicles[index].editAction = EditAction.NONE;
        }
        else {
            currentVehicle.editAction = EditAction.SELECTED;
            selectedVehicles.push(currentVehicle);
        }

        const sortedVehicles = sortVehicles(selectedVehicles);
        currentCutout.vehicles = sortedVehicles;

        setCutout(currentCutout);
    };

    const handleDeselectVehicle = (vehicle: VehicleModel) => {
        const currentCutout = { ...cutout };
        const selectedVehicles = currentCutout.vehicles;

        const index = selectedVehicles.findIndex(v => v.id === vehicle.id);

        if (selectedVehicles[index].editAction == EditAction.SELECTED) {
            selectedVehicles.splice(index, 1);
        }
        else if (selectedVehicles[index].editAction == EditAction.NONE) {
            selectedVehicles[index].editAction = EditAction.DELETE;
        }

        setCutout(currentCutout);
    };
    
    return (
        <Grid
            container
            direction="row"
            spacing={3}>

            <Grid item xs={12} sm={6}>
                <FilterChipsSearchField
                    key="cutout-vehicle-search-field"
                    searchText={ searchText }
                    setSearchText={ setSearchText } />
            </Grid>

            <Grid item xs={12} sm={12}>
                <CutoutVehicleChipList
                    key="cutout-vehicle-chip-list"
                    selectedVehicles={ cutout.vehicles }
                    vehicleList={ vehicleList }
                    searchText={ searchText }
                    onSelectVehicle={ handleSelectVehicle }
                    onDeselectVehicle={ handleDeselectVehicle }/>
            </Grid>

        </Grid>
    );
}